import Raven from 'raven-js';
import { Component } from 'react';
export const ErrorBoundaryNames = {
  PURCHASE_MOTION_CTA: 'PurchaseMotionCTA',
  TRIAL_BUTTON: 'TrialButton',
  ASSIGN_SEAT_BUTTON: 'AssignSeatButton',
  PRICING_PAGE_REDIRECT_BUTTON: 'PricingPageRedirectButton',
  REQUEST_SEAT_BUTTON: 'RequestSeatButton',
  TALK_TO_SALES_BUTTON: 'TalkToSalesButton',
  VIEW_ACCOUNT_BUTTON: 'ViewAccountButton',
  BUYING_BUTTON: 'BuyingButton'
};

// props passed in when withErrorBoundary is called

export class ErrorBoundary extends Component {
  constructor(...args) {
    super(...args);
    this.state = {
      hasError: false
    };
  }
  static getDerivedStateFromError() {
    return {
      hasError: true
    };
  }
  componentDidCatch(error, info) {
    Raven.captureException(new Error('Error boundary caught uncaught exception', {
      cause: error
    }), {
      extra: {
        boundaryName: this.props.boundaryName,
        info
      }
    });
  }
  render() {
    if (this.state.hasError) {
      const {
        boundaryName
      } = this.props;
      console.error('ErrorBoundary caught uncaught error', boundaryName);
      return null;
    }
    return this.props.children;
  }
}